import { render, staticRenderFns } from "./TalentRecruitment.vue?vue&type=template&id=fbd2c8bc&scoped=true&"
import script from "./TalentRecruitment.vue?vue&type=script&lang=js&"
export * from "./TalentRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./TalentRecruitment.vue?vue&type=style&index=0&id=fbd2c8bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2c8bc",
  null
  
)

export default component.exports